/**
 * 站点主体与备案信息。
 *
 * 这些值直接对应工信部备案系统里登记的内容，改动前必须确认与备案一致，
 * 否则专项核查会判定不合规。网站名称尤其注意：备案登记的是「好学文化」。
 */
export const site = {
  name: "好学文化",
  domain: "https://tengyunzi.cn",
  icp: "辽ICP备2026017584号-1",
  mps: "辽公网安备21011202001374号",
  mpsRecordCode: "21011202001374",
  company: "沈阳好学文化传媒有限公司",
  address: "辽宁省沈阳市浑南区凤凰大街77-9-22号(2门)",
  legalRepresentative: "滕柏嘉",
  email: "pangdahai2@studiousmedia.cn",
  serviceWechat: "wenzhen-bazi",
} as const;

/** 备案登记的接入与服务器信息，展示在备案合规中心。 */
export const filing = {
  registrar: "腾讯云计算（北京）有限责任公司",
  accessProvider: "腾讯云轻量应用服务器",
  serverRegion: "上海",
  serverIp: "110.42.238.201",
  dnsProvider: "DNSPod",
  dnsServers: ["mizar.dnspod.net", "shell.dnspod.net"],
  serviceCategory: "文化、教育、学习资料类网站",
  siteDescription:
    "提供传统文化资料整理、四柱表格工具、案例记录、古籍资料在线阅读与学习笔记管理。",
  entityType: "有限责任公司（自然人独资）",
} as const;

export const MIIT_URL = "https://beian.miit.gov.cn/";
const MPS_URL = "https://beian.mps.gov.cn/#/query/webSearch";

/** 公安联网备案链接：官方要求的查询地址，带上备案数据码。 */
export function mpsUrl(): string {
  const code = site.mpsRecordCode || site.mps.match(/\d{12,}/)?.[0] || "";
  return code ? `${MPS_URL}?code=${code}` : MPS_URL;
}

/** 备案号是否已落实（页脚据此决定是否展示为有效备案）。 */
export const hasIcp = !site.icp.includes("待备案");
export const hasMps = !site.mps.includes("待公安");

export const legalNotice =
  "内容仅供传统文化学习和娱乐参考，不替代医疗、投资、法律、婚姻等现实决策。";
